import {
  AlertColor,
  BaseColor,
  StrongColor,
} from "@merge-api/merge-javascript-shared/dist/designSystem/types";
import { ChecklistStatusValue } from "../../../constants";
import { AlertTriangle, CircleCheck } from "lucide-react";

export interface ChecklistDetail {
  title: string;
  badgeColor: BaseColor | StrongColor;
  alertColor: AlertColor;
  icon: JSX.Element;
}

export const CHECKLIST_VALUE_DISPLAY_DETAILS: Partial<Record<
  ChecklistStatusValue,
  ChecklistDetail
>> = {
  [ChecklistStatusValue.NOT_IMPLEMENTED]: {
    title: "Missing",
    badgeColor: "yellow",
    alertColor: "yellow",
    icon: <AlertTriangle color="black" size={16} />,
  },
  [ChecklistStatusValue.NOT_SUPPORTED]: {
    title: "Unsupported",
    badgeColor: "gray",
    alertColor: "gray",
    icon: <AlertTriangle color="gray" size={16} />,
  },
  [ChecklistStatusValue.IMPLEMENTED]: {
    title: "Completed",
    badgeColor: "green",
    alertColor: "green",
    icon: <CircleCheck color="black" size={16} />,
  },
};

export const GRAFANA_DEPLOYMENT_LOGS_URL_LAST_30_MINUTES =
  "https://grafana-main.tools.merge.land/d/bf0kidwqila0wc/deployment-logs-shared-with-randd?orgId=1&from=now-30m&to=now&timezone=browser&var-env_id=deezg3unp3qwwe&var-deployment_name=merge-backend-celery-mapping-tests&var-log_group=%2Faws%2Feks%2Fmerge-production%2Fec2&var-Filters=";
